
let data = {
  cart: {}, 
  update(newCart) {
    this.cart = newCart
  },
  setRedirect(e) {
    e.preventDefault();
    goToCheckout();
  }
};

const $minicart = $('[data-minicart]');

if (tinybind) {  
  tinybind.formatters.formatMoney = formatMoney;
  tinybind.formatters.isDefaultTitle = function (title) {
    if (title.toLowerCase() == "default title") return false;
    return true;
  };
  tinybind.formatters.append = function(value, append) {
    return value+append;
  }
  tinybind.formatters.convert = function(value, append) {
    if (append) {
      return '/products/'+append;
    }
    return value
  }
  tinybind.bind($minicart, data);
} else {
  console.error("minicart.js: Tinybind template library is not connected");  
}

function updateMinicart() {
  $.get('/cart.js', function(response) {
    data.update(response);     
  }, 'json').fail(function() {
    console.error('minicart.js: updateMinicart error')
  })
}

updateMinicart();

async function removeItemsFromMiniCart(linesToRemove) {
  try {

    const updates = {};
    linesToRemove.forEach(line => {
      const id = line.line ? line.line : line.id;
        updates[id] = 0;
    });
      const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify({updates})
      });

      const cart = await response.json();
      return cart;
  } catch (error) {
      console.error('Error updating cart:', error);
      return null;
  }
}



$(document).ready(function(){ 
  /**
    * Added fallback function to closed the popup cart screen
    */
  $(document).on('click', '.close_mini_cart a', function(e){
    event.preventDefault(); 
    $('.minicart').addClass('minicart--hide');
  });
  
  $(document).on('click', '[data-minicart-remove]', function(e){
    const variantId = $(this).closest('[data-minicart-item]').data('id');
    const feeBundleId = $(this).closest('[data-minicart-item]').data('fee-bundle-id');

    let removeLines = [{ quantity: 0, id: variantId }];
    // let removeLines = {variantId: 0};
    if(feeBundleId) {
      // Check for fee product  
      getBundleItems(feeBundleId).then(res =>  {
        if(res && res.length>0) {
          removeLines = res
        }
        removeItemsFromMiniCart(removeLines).then(updatedCart => {
          updateMinicart();
        });

      });
      
    } else {
      removeItemsFromMiniCart(removeLines).then(updatedCart => {
        updateMinicart();
      });
    }
  
    // $.post('/cart/change.js', linesToRemove, function(response){
    //   updateMinicart();
    // }, 'json');
  });
  
  $(document).on('click', '.action_button.add_to_cart', function(e){
    e.preventDefault();
    let addToCartForm = document.querySelector('form[action="/cart/add"]');
    let formData = new FormData(addToCartForm);
  
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => {
      if ( response.status === 422 ) {
        response.json().then(function(json) {
          alert(json.message);
        });

        return;
      }

      updateMinicart();
      $minicart.removeClass('minicart--hide');
      $('.minicart--btn').addClass('minicart__cart--white');  
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  });

  $('.site-header__cart').hover(function() {      
    $(this).addClass('minicart__cart--white');     
  }, function() {
    $(this).removeClass('minicart__cart--white');  
  });  
  $('.minicart--btn').hover(function() {
    $('.minicart').removeClass('minicart--hide');  
    $(this).addClass('minicart__cart--white');     
  }, function() {
    $('.minicart').addClass('minicart--hide'); 
    $(this).removeClass('minicart__cart--white');  
  });    
  $('.minicart').hover(function() {
    $('.minicart').removeClass('minicart--hide'); 
    $('.minicart--btn').addClass('minicart__cart--white');      
  }, function() {
    $('.minicart').addClass('minicart--hide'); 
    $('.minicart--btn').removeClass('minicart__cart--white');  
  });
});




